module.exports = __webpack_public_path__ + "img/packing.761802c2.svg";